import React, {useEffect, useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';
import moment from 'moment';
import {refreshToken} from '../_redux/authActions';
import config from '../../../../config/common';
import {SplashScreen} from '../../../../_metronic/_partials/controls';

export const RefreshTokenWrapper = ({children}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const accessToken = useSelector(state => state.auth?.accessToken, shallowEqual);
  const expire = useSelector(state => state.auth?.expire, shallowEqual);

  const checkAndRefreshToken = async () => {
    try {
      await dispatch(refreshToken(accessToken));
    } catch (err) {
      console.error('error on refresh token', err);
      history.push('/logout');
    }
  };

  const checkTokenExpire = () => {
    if (!expire) return false;

    const expireMoment = moment.unix(expire).subtract(config.refreshGap);
    const currentMoment = moment();

    return currentMoment.isSameOrAfter(expireMoment);
  };

  useEffect(() => {
    if (checkTokenExpire()) {
      setLoading(true);
      checkAndRefreshToken()
        .finally(() => setLoading(false));
    }
  }, [location.pathname, expire]);

  return loading ? <SplashScreen/> : children;
};
